// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-list-container {
  padding: 2rem;
  max-width: var(--max-width);
  margin: 0 auto;
}

.recipe-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.recipe-list-header h2 {
  font-size: 2rem;
  color: var(--secondary-text);
  margin: 0;
}

.recipe-search-form {
  display: flex;
  gap: 0.5rem;
}

.recipe-search-input {
  padding: 0.5rem 1rem;
  border: 2px solid var(--accent-color);
  border-radius: var(--border-radius);
  font-size: 1rem;
  min-width: 200px;
  transition: all var(--transition-speed) ease;
}

.recipe-search-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--accent-color);
}

.recipe-search-button {
  background-color: var(--accent-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all var(--transition-speed) ease;
}

.recipe-search-button:hover {
  background-color: var(--primary-bg);
  transform: translateY(-2px);
}

.recipe-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

.pagination-button {
  background-color: var(--accent-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all var(--transition-speed) ease;
}

.pagination-button:hover:not(:disabled) {
  background-color: var(--primary-bg);
  transform: translateY(-2px);
}

.pagination-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  color: var(--secondary-text);
}

.error-message {
  color: var(--error-color);
  background-color: rgba(255, 68, 68, 0.1);
  padding: 1rem;
  border-radius: var(--border-radius);
  text-align: center;
}

.no-recipes-message {
  text-align: center;
  color: var(--secondary-text);
  padding: 2rem;
  font-size: 1.1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .recipe-list-container {
    padding: 1rem;
  }

  .recipe-list-header {
    flex-direction: column;
    align-items: stretch;
  }

  .recipe-search-form {
    width: 100%;
  }

  .recipe-search-input {
    flex: 1 1;
  }

  .recipe-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .recipe-grid {
    grid-template-columns: 1fr;
  }

  .pagination {
    flex-direction: column;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/RecipeList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".recipe-list-container {\n  padding: 2rem;\n  max-width: var(--max-width);\n  margin: 0 auto;\n}\n\n.recipe-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.recipe-list-header h2 {\n  font-size: 2rem;\n  color: var(--secondary-text);\n  margin: 0;\n}\n\n.recipe-search-form {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.recipe-search-input {\n  padding: 0.5rem 1rem;\n  border: 2px solid var(--accent-color);\n  border-radius: var(--border-radius);\n  font-size: 1rem;\n  min-width: 200px;\n  transition: all var(--transition-speed) ease;\n}\n\n.recipe-search-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--accent-color);\n}\n\n.recipe-search-button {\n  background-color: var(--accent-color);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: all var(--transition-speed) ease;\n}\n\n.recipe-search-button:hover {\n  background-color: var(--primary-bg);\n  transform: translateY(-2px);\n}\n\n.recipe-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.pagination-button {\n  background-color: var(--accent-color);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: all var(--transition-speed) ease;\n}\n\n.pagination-button:hover:not(:disabled) {\n  background-color: var(--primary-bg);\n  transform: translateY(-2px);\n}\n\n.pagination-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  color: var(--secondary-text);\n}\n\n.error-message {\n  color: var(--error-color);\n  background-color: rgba(255, 68, 68, 0.1);\n  padding: 1rem;\n  border-radius: var(--border-radius);\n  text-align: center;\n}\n\n.no-recipes-message {\n  text-align: center;\n  color: var(--secondary-text);\n  padding: 2rem;\n  font-size: 1.1rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .recipe-list-container {\n    padding: 1rem;\n  }\n\n  .recipe-list-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .recipe-search-form {\n    width: 100%;\n  }\n\n  .recipe-search-input {\n    flex: 1;\n  }\n\n  .recipe-grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .recipe-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pagination {\n    flex-direction: column;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
